import { SitesListPage } from '@/pages/inspection/sites/SitesListPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const sitesSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(25),
	search: z.string().optional(),
	status: z.string().optional(),
	sort: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/inspection/sites/')({
	component: SitesListPage,
	validateSearch: sitesSearchSchema,
});
